import { render, staticRenderFns } from "./NodeStudioDownload.vue?vue&type=template&id=0be9d742&scoped=true"
import script from "./NodeStudioDownload.vue?vue&type=script&lang=js"
export * from "./NodeStudioDownload.vue?vue&type=script&lang=js"
import style0 from "./NodeStudioDownload.vue?vue&type=style&index=0&id=0be9d742&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be9d742",
  null
  
)

export default component.exports